import {
  GraphQlClient,
} from '@intelipost-js/secure-providers';

import {
  ScToast,
} from '@intelipost-js/secure-components';

export default {
  getinvoicePeriods({ commit }) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query {
        invoicePeriods {
          month_report,
          date_range {
            start
            end
          }
        }
      }`)
      .then((res) => {
        const { data = {} } = res || {};
        const { invoicePeriods = [] } = data || {};

        commit('toggleLoading', false);
        commit('setinvoicePeriods', invoicePeriods);
        commit('setForm', invoicePeriods[0]);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  getinvoiceExtract({ commit }, form) {
    const { date_range } = form;

    commit('toggleLoading', true);

    return GraphQlClient.query(
      `
        query ($date_range: DateRangeInput!) {
          invoiceExtract(date_range: $date_range) {
            message
          }
        }
      `, {
        date_range,
      })
      .then((res) => {
        const { data = {} } = res || {};
        const { invoiceExtract = {} } = data || {};
        const { message } = invoiceExtract || {};

        commit('toggleLoading', false);
        ScToast.success(message);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./src/features/private/client-environment/pages/invoice-extract/store/actions.js